import { useCallback, useMemo } from 'react';
import {
  selectMeteorologyAgroCultureIndexLocationForecastDate,
  setForecastDate as setForecastDateRedux,
} from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';
import {
  format,
  parse,
} from 'date-fns';
import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import useForecastDates from '../useForecastDates';

export default function useForecastDate() {
  const { forecastDates } = useForecastDates();
  const availableDates = forecastDates.map((date) => parse(date, 'yyyy-MM-dd', new Date()));
  const formattedDate = useSelector(selectMeteorologyAgroCultureIndexLocationForecastDate);
  const forecastDate = useMemo(() => (
    formattedDate ? parse(formattedDate, 'yyyy-MM-dd', new Date()) : null
  ), [formattedDate]);

  const setForecastDate = useCallback((date: Date | null) => {
    const newDate = date ? format(date, 'yyyy-MM-dd') : undefined;
    store.dispatch(setForecastDateRedux(newDate));
  }, []);

  return {
    availableDates,
    forecastDate,
    setForecastDate,
  };
}
